import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const HeadMetaData = () => {
  const location = useLocation();
  const [title, setTitle] = useState("");

  useEffect(() => {
    const header1List = document.getElementsByTagName("h1");
    const header2List = document.getElementsByTagName("h2");

    if (header1List) {
      setTitle(header1List[0]?.innerText || header2List[0]?.innerText);
    }
  }, [location]);

  useEffect(() => {
    document.title = `${title || "JUMBOMedia"} - JUMBOMedia`;
  }, [title]);

  return null;
};

export default HeadMetaData;
